import { SDK } from './sdk.js'
import SDKAdapter from './core/adapter.js'
import { SDKModel } from './core/model.js'
export * from './core/transport.js'
export * from './models/collections.js'
export * from './models/components.js'
export * from './models/datasources.js'
export * from './models/libraries.js'
export * from './models/stylesheets.js'
export * from './models/versions.js'
export * from './models/version-bundles.js'
export * from './models/auth.js'
export * from './models/external/tenants.js'
export * from './models/external/xm-templates.js'
export * from './models/external/content-hub-one-content-types.js'
export * from './models/external/external-components.js'
export * from './models/external/rendering-host.js'
export * from './sdk.js'
export * from './core/model.js'
export * from './core/schema.js'
export { SDKAdapter }
export * from './core/collection.js'

SDK.instance = new SDK({
  apiKey: typeof process != 'undefined' ? process.env.FEAAS_SDK_KEY : null,
  accessToken: typeof process != 'undefined' ? process.env.FEAAS_SDK_ACCESS_TOKEN : null,
  backend: typeof process != 'undefined' ? process.env.FEAAS_SDK_HOSTNAME : null
})
SDKModel.prototype.sdk = SDK.instance

export default SDK
